<template>
  <v-container fluid class="paystatement-list mt-3">
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="paystatements-table"
              show-select
              single-select
              item-key="_id"
              sort-desc
              sort-by="paystatementnum"
              :footer-props="footer"
              :headers="headers"
              :items="paystatements"
              :items-per-page="itemPerPage">
              <template v-slot:item.employeeid="{ item }">
                <v-avatar v-if="employees.length>0" size="40">
                  <img v-bind:src="employees.find(employee=>employee._id == item.employeeid)['employeeimage']" alt="">
                </v-avatar>
                <v-avatar
                  v-else
                  color="warning"
                  size="40">
                  <span class="white--text headline">{{ employees.length>0 ? employees.find(employee=>employee._id == item.employeeid)['employeename'][0].toUpperCase() : '' }}</span>
                </v-avatar>
                <span style="margin-left:15px">{{ item.paystatementname }} </span>
              </template>
              <template v-slot:item.paystatementnum="{ item }">
                <p class="two-line">{{ item.paystatementtype  }}</p>
                <p class="two-line">{{ item.paystatementnum  }}</p>
              </template>
              <template v-slot:item.paystatementaddress="{ item }">
                <p class="two-line">{{ item.paystatementaddress }}</p>
              </template>
              <template v-slot:item.paystatementstatus="{ item }">
                <v-chip
                  :color="item.paystatementstatus=='Complete' ? 'successConst white--text' : 'secondaryConst white--text'"
                  small>
                  {{ item.paystatementstatus }}
                </v-chip>
              </template>
              <template v-slot:item.paystatementdate="{ item }">
                {{ new Date(item.paystatementdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.paystatementnetpay="{ item }">
                {{ item.paystatementnetpay!=null ? item.paystatementnetpay.toLocaleString('en-SG') : '' }}
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="printItem(item)">
                  <v-icon>mdi-printer</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import config from "../../../../config"
import { mapState, mapActions } from 'vuex'

export default {
  name: 'PayStatementList',
  data() {
    return {
      config,
      itemPerPage: 500,
      footer: {'items-per-page-options': [500, 1000, 5000]},
      selected: [],
      paystatements: [],
      headers: [
        { text: 'Num', value: 'paystatementnum' },
        { text: 'Date', value: 'paystatementdate' },
        { text: 'Employee', value: 'employeeid' },
        { text: 'Net Pay', value: 'paystatementnetpay' },
        { text: 'Status', value: 'paystatementstatus' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
    }
  },
  computed: {
    ...mapState('MyAccount', ['isReceiving', 'isDeleting']),
    ...mapState('Employee', ['employees']),
  },
  async created () {
    this.paystatements = await this.getMyStatementsRequest();
    if(this.employees.length==0) {this.getEmployeesRequest()}
  },
  methods: {
    ...mapActions('MyAccount', ["getMyStatementsRequest"]),
    ...mapActions('Employee', ["getEmployeesRequest"]),
    printItem(item) {
      let params = Object.assign({}, item);
      params.isFromMyStatement = true;
      this.$router.push({ name: 'PayStatementPrint', params: params })
    },
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
